export const TIME_UNITS = {
    WEEK: 'week',
    MONTH: 'month'
};
